<app-nav-bar></app-nav-bar>

<div class="max-w-[1360px] mx-auto px-5 py-7 lg:py-10">
    <!-- Top Section: Cards Layout (Horizontal) -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 pb-10 border-b border-secondary-button-black">

        <!-- Left Card: Profile Info -->
        <div
            class="bg-white border border-secondary-button-black rounded-[20px] p-6 flex flex-col justify-between h-full">
            <div>
                <div class="flex items-start justify-between">
                    <div class="flex items-center gap-4">
                        <div class="flex items-center justify-center w-[60px] h-[60px] rounded-full bg-secondary-button-black text-black font-bold text-2xl uppercase max-[576px]:w-[50px] max-[576px]:h-[50px] max-[576px]:text-xl"
                            *ngIf="!profilePicture">
                            {{ userDetails?.username?.charAt(0) || tradingStats?.user_name?.charAt(0) }}
                        </div>
                        <img [src]="profilePicture" *ngIf="profilePicture"
                            alt="profile" class="w-[60px] h-[60px] rounded-full object-cover">
                        <div class="flex flex-col gap-1">
                            <div class="flex items-center gap-2">
                                <h2 class="text-black font-medium text-2xl lg:text-3xl line-clamp-1 max-[576px]:text-xl">
                                    {{ truncateUsername(tradingStats?.user_name) }}
                                </h2>
                                <div class="flex items-center gap-2">
                                    <!-- Scan/User Icon -->
                                    <!-- <button class="p-1 text-secondary-text-black hover:text-black transition-colors">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26"
                                            viewBox="0 0 26 26" fill="none">
                                            <path
                                                d="M4 9.38747C4.09858 7.39826 4.39351 6.15803 5.27576 5.27576C6.15803 4.39351 7.39826 4.09858 9.38747 4M22 9.38747C21.9014 7.39826 21.6065 6.15803 20.7243 5.27576C19.842 4.39351 18.6017 4.09858 16.6125 4M16.6125 22C18.6017 21.9014 19.842 21.6065 20.7243 20.7243C21.6065 19.842 21.9014 18.6017 22 16.6125M9.38746 22C7.39826 21.9014 6.15803 21.6065 5.27576 20.7243C4.39351 19.842 4.09858 18.6017 4 16.6125"
                                                stroke="black" stroke-opacity="0.8" stroke-width="1.13684"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M18.2101 17.7355L18.0186 16.9313C17.8603 16.2668 17.3564 15.7389 16.7001 15.5498L14.4206 14.8928L14.4204 13.5025C15.2699 12.9291 15.8414 11.8576 15.8414 10.6302C15.8414 8.79898 14.5689 7.31445 12.9993 7.31445C11.4296 7.31445 10.1572 8.79898 10.1572 10.6302C10.1572 11.8576 10.7287 12.9291 11.5783 13.5025L11.5785 14.8928L9.31324 15.556C8.67719 15.7422 8.18466 16.2472 8.01441 16.8877L7.78906 17.7355"
                                                stroke="black" stroke-opacity="0.8" stroke-width="1.13684"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </button> -->
                                    <!-- Gift Icon -->
                                    <!-- <button (click)="openRewardModal()"
                                        class="p-1 text-secondary-text-black hover:text-black transition-colors cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                            viewBox="0 0 24 24" fill="none">
                                            <path d="M20 12V22H4V12" stroke="currentColor" stroke-width="1.5"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22 7H2V12H22V7Z" stroke="currentColor" stroke-width="1.5"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 22V7" stroke="currentColor" stroke-width="1.5"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7ZM12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7Z"
                                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </button> -->
                                </div>
                            </div>
                            <div class="flex items-center gap-2 text-secondary-text-black text-sm font-medium">
                                <span>Joined {{ (userDetails?.created_at | date:'MMM yyyy') }}</span>
                                <!-- <span>.</span> -->
                                <!-- <span>{{ userDetails?.views || '12.5k' }} views</span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-3 gap-4 mt-5">
                <div class="flex flex-col gap-1">
                    <p class="text-black font-semibold text-lg max-[576px]:text-base">${{ (tradingStats?.position_value || 0) | number:'1.1-2'
                        }}</p>
                    <p class="text-secondary-text-black text-xs font-medium">Positions Value</p>
                </div>
                <div class="flex flex-col gap-1 border-l border-secondary-button-black pl-4">
                    <p class="text-black font-semibold text-lg max-[576px]:text-base">${{ (tradingStats?.biggest_win || 0) | number:'1.1-2' }}
                    </p>
                    <p class="text-secondary-text-black text-xs font-medium">Biggest Win</p>
                </div>
                <div class="flex flex-col gap-1 border-l border-secondary-button-black pl-4">
                    <p class="text-black font-semibold text-lg max-[576px]:text-base">{{ tradingStats?.predictions || 0 }}</p>
                    <p class="text-secondary-text-black text-xs font-medium">Predictions</p>
                </div>
            </div>
        </div>

        <!-- Right Card: Profit Graph -->
        <div
            class="bg-white border border-secondary-button-black rounded-[20px] p-4 flex flex-col h-full relative overflow-hidden">
            <div class="flex items-start justify-between relative z-10">
                <div class="flex flex-col gap-1">
                    <div class="flex items-center gap-1.5 text-primary-text-green text-sm font-medium">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M6 9V3M6 3L3 6M6 3L9 6" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Profit/Loss
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text-secondary-text-black opacity-60">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8"></line>
                        </svg>
                    </div>
                    <h2 class="text-black font-bold text-2xl lg:text-3xl max-[576px]:text-xl">
                        {{ formatCurrency(currentProfitLossValue, true) }}
                    </h2>
                    <p class="text-secondary-text-black text-xs font-medium">
                        {{ activeProfitInterval === 'ALL' ? 'All Time' : activeProfitInterval }}
                    </p>
                </div>
                <ul class="flex items-center gap-1 bg-[#F5F5F5] border border-secondary-button-black rounded-lg p-1">
                    <li (click)="setProfitInterval('1D')"
                        class="px-2.5 py-1 text-[10px] font-semibold cursor-pointer transition-colors rounded-md"
                        [ngClass]="activeProfitInterval === '1D' ? 'bg-white text-black shadow-sm border border-secondary-button-black/10' : 'text-secondary-text-black hover:text-black'">
                        1D</li>
                    <li (click)="setProfitInterval('1M')"
                        class="px-2.5 py-1 text-[10px] font-semibold cursor-pointer transition-colors rounded-md"
                        [ngClass]="activeProfitInterval === '1M' ? 'bg-white text-black shadow-sm border border-secondary-button-black/10' : 'text-secondary-text-black hover:text-black'">
                        1M</li>
                    <li (click)="setProfitInterval('1W')"
                        class="px-2.5 py-1 text-[10px] font-semibold cursor-pointer transition-colors rounded-md"
                        [ngClass]="activeProfitInterval === '1W' ? 'bg-white text-black shadow-sm border border-secondary-button-black/10' : 'text-secondary-text-black hover:text-black'">
                        1W</li>
                    <li (click)="setProfitInterval('ALL')"
                        class="px-3 py-1 text-[10px] font-bold cursor-pointer transition-colors rounded-md"
                        [ngClass]="activeProfitInterval === 'ALL' ? 'bg-white text-black shadow-sm border border-secondary-button-black/10' : 'text-secondary-text-black hover:text-black'">
                        ALL</li>
                </ul>
            </div>

            <!-- Graph Area -->
            <div class="flex-1 mt-4 relative min-h-[120px]">
                <app-chart [chartData]="profitChartData" [showControls]="false" chartType="profit"
                    [activeInterval]="activeProfitInterval"></app-chart>
            </div>
        </div>
    </div>

    <!-- Main Content Tabs (Full Width Below) -->
    <div class="mt-8">
        <ul class="flex gap-8 border-b border-secondary-button-black">
            <li (click)="onMainTabChange('positions')"
                class="pb-3 text-lg font-semibold cursor-pointer transition-all relative"
                [ngClass]="activeMainTab === 'positions' ? 'text-black' : 'text-secondary-text-black hover:text-black'">
                Positions
                <div *ngIf="activeMainTab === 'positions'"
                    class="absolute bottom-0 left-0 w-full h-[2px] bg-primary-text-green"></div>
            </li>
            <li (click)="onMainTabChange('activity')"
                class="pb-3 text-lg font-semibold cursor-pointer transition-all relative max-[576px]:text-base"
                [ngClass]="activeMainTab === 'activity' ? 'text-black' : 'text-secondary-text-black hover:text-black'">
                Activity
                <div *ngIf="activeMainTab === 'activity'"
                    class="absolute bottom-0 left-0 w-full h-[2px] bg-primary-text-green"></div>
            </li>
        </ul>

        <!-- Positions Tab Content -->
        <div *ngIf="activeMainTab === 'positions'" class="mt-8">
            <div
                class="flex flex-row flex-wrap md:items-center max-[650px]:items-center justify-between gap-5 mb-8">
                <div class="flex items-center gap-2">
                    <div
                        class="flex border border-secondary-button-black rounded-lg overflow-hidden bg-[#F5F5F5] cursor-pointer">
                        <button (click)="onStatusChange('active')"
                            class="px-6 py-2.5 text-sm font-semibold transition-colors"
                            [ngClass]="activeStatus === 'active' ? 'bg-white text-black shadow-sm' : 'text-secondary-text-black hover:bg-gray-100'">
                            Active
                        </button>
                        <button (click)="onStatusChange('closed')"
                            class="px-6 py-2.5 text-sm font-semibold transition-colors border-l border-secondary-button-black"
                            [ngClass]="activeStatus === 'closed' ? 'bg-white text-black shadow-sm' : 'text-secondary-text-black hover:bg-gray-100'">
                            Closed
                        </button>
                    </div>
                </div>

                <div class="flex items-center gap-3 flex-1 max-[650px]:contents">
                    <div
                        class="flex-1 flex items-center gap-3 rounded-xl border border-secondary-button-black py-2.5 px-4 bg-white max-[650px]:order-2 max-[650px]:basis-full">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M18.5 18.5L22 22M21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21C16.7467 21 21 16.7467 21 11.5Z"
                                stroke="black" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <input type="text" placeholder="Search Positions" [(ngModel)]="searchQuery"
                            (ngModelChange)="onSearchChange()"
                            class="text-sm font-normal text-black placeholder:text-secondary-text-black border-0 p-0 w-full outline-none bg-transparent" />
                    </div>
                    <div class="relative max-[650px]:order-1">
                        <button #valueTrigger (click)="toggleValueDropdown()"
                            class="flex items-center gap-2 px-4 py-2.5 border border-secondary-button-black rounded-lg text-sm font-semibold bg-white cursor-pointer min-w-[150px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
                                <path d="M1 1H13.4M1 5.6H9.5M1 10.3H6.4" stroke="black" stroke-width="1.2" />
                            </svg>
                            {{ selectedValue }}
                        </button>
                        <!-- Sized and sided from the room left around the button, so the list
                             always fits on screen; anything past that scrolls inside the list
                             while the page behind it stays put -->
                        <ul *ngIf="isValueOpen" [style.maxHeight.px]="valueMenu.maxHeight"
                            [ngClass]="valueMenu.above ? 'bottom-full mb-2' : 'top-full mt-2'"
                            class="absolute right-0 w-40 overflow-y-auto overscroll-contain rounded-lg border border-secondary-button-black bg-white shadow-xl z-30">
                            <li *ngFor="let value of values" (click)="selectValue(value)"
                                class="px-4 py-3 text-sm font-medium cursor-pointer hover:bg-gray-50 border-b border-secondary-button-black last:border-b-0">
                                {{ value.label }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Positions Table -->
            <div class="overflow-x-auto positions-table-scroll">
                <table class="w-full text-left min-w-[1100px]">
                    <thead>
                        <tr class="border-b border-secondary-button-black">
                            <th
                                class="py-4 text-sm font-bold text-secondary-text-black uppercase tracking-wider min-w-[420px]">
                                Market
                            </th>
                            <ng-container *ngIf="activeStatus !== 'closed'">
                                <th
                                    class="py-4 text-sm font-bold text-secondary-text-black uppercase tracking-wider text-center w-[150px] min-w-[150px]">
                                    Avg</th>
                                <th
                                    class="py-4 text-sm font-bold text-secondary-text-black uppercase tracking-wider text-center w-[150px] min-w-[150px]">
                                    Current</th>
                                <th
                                    class="py-4 text-sm font-bold text-secondary-text-black uppercase tracking-wider text-right w-[150px] min-w-[150px]">
                                    Value</th>
                            </ng-container>
                            <ng-container *ngIf="activeStatus === 'closed'">
                                <th
                                    class="py-4 text-sm font-bold text-secondary-text-black uppercase tracking-wider text-center w-[150px] min-w-[150px]">
                                    Result</th>
                                <th
                                    class="py-4 text-sm font-bold text-secondary-text-black uppercase tracking-wider text-center w-[150px] min-w-[150px]">
                                    Total Bet</th>
                                <th
                                    class="py-4 text-sm font-bold text-secondary-text-black uppercase tracking-wider text-right w-[150px] min-w-[150px]">
                                    Amount Won</th>
                            </ng-container>
                            <th class="py-4 w-16 min-w-[64px]"></th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-secondary-button-black">
                        <!-- Loading State -->
                        <tr *ngIf="loading">
                            <td colspan="10" class="py-20 text-center">
                                <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-black mx-auto"></div>
                            </td>
                        </tr>

                        <!-- Empty State -->
                        <tr *ngIf="!loading && positions.length === 0">
                            <td colspan="10" class="py-20 text-center text-secondary-text-black font-medium">
                                No {{ activeStatus }} positions found.
                            </td>
                        </tr>

                        <!-- Data Rows -->
                        <tr *ngFor="let pos of positions" class="group hover:bg-gray-50 transition-colors">
                            <td class="py-5 cursor-pointer min-w-[420px]" (click)="navigateToMarket(pos)">
                                <div class="flex items-center gap-4">
                                    <div class="relative min-w-[48px]">
                                        <img [src]="pos.market_image_url || 'assets/images/leaderboard/popular-image1.png'"
                                            class="w-12 h-12 rounded-full object-cover">
                                    </div>
                                    <div class="flex flex-col gap-1">
                                        <p class="font-bold text-black group-hover:underline leading-tight max-[576px]:text-sm">
                                            {{ pos.market_name }}</p>
                                        <div class="flex items-center gap-2 whitespace-nowrap">
                                            <span class="px-1.5 py-0.5 rounded text-[10px] font-bold uppercase"
                                                [ngClass]="pos.outcome_title?.toLowerCase() === 'yes' ? 'bg-primarybg-green text-primary-text-green' : 'bg-primarybg-yellow text-primary-text-yellow'">
                                                {{ pos.outcome_title }}
                                            </span>
                                            <span class="text-secondary-text-black text-sm font-medium">
                                                {{ pos.shares | number:'1.0-0' }} shares at {{ (pos.avg_price_numeric *
                                                100) | number:'1.0-1' }}¢
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <ng-container *ngIf="activeStatus !== 'closed'">
                                <td
                                    class="py-5 text-center font-bold text-black text-sm w-[200px] min-w-[200px] whitespace-nowrap">
                                    {{ (pos.avg_price_numeric *
                                    100) | number:'1.0-1' }}¢</td>
                                <td
                                    class="py-5 text-center font-bold text-black text-sm w-[200px] min-w-[200px] whitespace-nowrap">
                                    {{ (pos.current_price_numeric
                                    * 100) | number:'1.0-1' }}¢</td>
                                <td class="py-5 text-right w-[200px] min-w-[200px] whitespace-nowrap">
                                    <div class="flex flex-col items-end">
                                        <p class="font-bold text-black text-sm">${{ pos.value_numeric | number:'1.2-2'
                                            }}</p>
                                        <p class="text-sm font-bold"
                                            [ngClass]="pos.total_pnl_numeric >= 0 ? 'text-primary-text-green' : 'text-primary-text-yellow'">
                                            {{ pos.total_pnl_numeric >= 0 ? '+' : '' }}${{ pos.total_pnl_numeric |
                                            number:'1.2-2' }} ({{ (pos.profit_loss_pct || 0) | number:'1.1-1' }}%)
                                        </p>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container *ngIf="activeStatus === 'closed'">
                                <td class="py-5 text-center w-[200px] min-w-[200px] whitespace-nowrap">
                                    <span
                                        class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold uppercase"
                                        [ngClass]="pos.total_pnl_numeric >= 0 ? 'bg-primarybg-green text-primary-text-green' : 'bg-primarybg-yellow text-primary-text-yellow'">

                                        <!-- Green Tick for Won -->
                                        <svg *ngIf="pos.total_pnl_numeric >= 0" xmlns="http://www.w3.org/2000/svg"
                                            width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>

                                        <!-- Yellow Cross for Lost -->
                                        <svg *ngIf="pos.total_pnl_numeric < 0" xmlns="http://www.w3.org/2000/svg"
                                            width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="18" y1="6" x2="6" y2="18"></line>
                                            <line x1="6" y1="6" x2="18" y2="18"></line>
                                        </svg>

                                        {{ pos.total_pnl_numeric >= 0 ? 'Won' : 'Lost' }}
                                    </span>
                                </td>
                                <td
                                    class="py-5 text-center font-bold text-black text-sm w-[200px] min-w-[200px] whitespace-nowrap">
                                    ${{ pos.amount_bet |
                                    number:'1.2-2' }}</td>
                                <td class="py-5 text-right w-[200px] min-w-[200px] whitespace-nowrap">
                                    <div class="flex flex-col items-end">
                                        <p class="font-bold text-black text-sm">${{ pos.value_numeric | number:'1.2-2'
                                            }}</p>
                                        <p class="text-xs font-bold"
                                            [ngClass]="pos.total_pnl_numeric >= 0 ? 'text-primary-text-green' : 'text-primary-text-yellow'">
                                            {{ pos.total_pnl_numeric >= 0 ? '+' : '' }}${{ pos.total_pnl_numeric |
                                            number:'1.2-2' }}
                                        </p>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- <td class="py-5 text-right pl-4">
                                <button (click)="openShareModal()"
                                    class="p-1.5 hover:bg-light-black-300 rounded-lg transition-colors border border-secondary-button-black/20">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none">
                                        <path
                                            d="M3 17C3 17.93 3 18.395 3.10222 18.7765C3.37962 19.8117 4.18826 20.6204 5.22354 20.8978C5.60504 21 6.07002 21 7 21H17C17.93 21 18.3949 21 18.7764 20.8978C19.8117 20.6204 20.6203 19.8117 20.8977 18.7765C20.9999 18.395 21 17.93 21 17"
                                            stroke="black" stroke-opacity="0.8" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M16.5 7.49997C16.5 7.49997 13.1858 3.00001 12 3C10.8142 2.99999 7.5 7.5 7.5 7.5M12 4V16"
                                            stroke="black" stroke-opacity="0.8" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Activity Tab Content -->
        <div *ngIf="activeMainTab === 'activity'" class="mt-8">
            <div class="flex flex-col gap-3">
                <div *ngFor="let act of activities"
                    class="bg-white border border-secondary-button-black rounded-xl p-4 flex items-center justify-between hover:bg-gray-100 transition-colors">
                    <div class="flex items-center gap-4">
                        <img [src]="act.market_image_url || 'assets/images/leaderboard/popular-image1.png'"
                            class="w-10 h-10 rounded-full object-cover">
                        <div class="flex flex-col gap-1">
                            <!-- Activity text: 0x0f51...2ceb sold 2 Moon Mission at 25.0¢ ($0.5) -->
                            <p class="font-bold text-sm text-gray-800 flex items-center gap-1 flex-wrap">
                                <span class="max-w-[150px] truncate inline-block">
                                    {{ getActivityActorName(act) }}
                                </span>

                                <!-- Quantity, price of one share and what the trade came to,
                                     each named so none can be read as another -->
                                <ng-container *ngIf="getActivityTrade(act) as trade">
                                    {{ trade.action }}

                                    <span [ngClass]="{
                                        'text-red-500': trade.action === 'sold',
                                        'text-primary-text-green': trade.action === 'bought'
                                    }">
                                        {{ trade.shares }} {{ trade.outcome }}
                                    </span>

                                    <ng-container *ngIf="trade.pricePerShareCents !== null">
                                        at {{ trade.pricePerShareCents | number:'1.1-1' }}¢
                                    </ng-container>

                                    <ng-container *ngIf="trade.total !== null">
                                        (${{ trade.total | number:'1.1-2' }})
                                    </ng-container>
                                </ng-container>
                            </p>
                            <div class="flex items-center gap-2">
                                <!-- <span class="text-xs font-bold capitalize"
                                    [ngClass]="act.side?.toLowerCase() === 'buy' || act.side?.toLowerCase() === 'bought' ? 'text-primary-text-green' : 'text-red-600'">
                                    {{ act.side }}
                                </span> -->
                                <!-- <span class="px-1.5 py-0.5 rounded text-[10px] font-bold uppercase"
                                    [ngClass]="act.outcome_title?.toLowerCase() === 'yes' ? 'bg-primarybg-green text-primary-text-green' : 'bg-primarybg-yellow text-primary-text-yellow'">
                                    {{ act.outcome_title || act.outcome || 'YES' }}
                                </span> -->
                                <!-- <span class="text-secondary-text-black text-xs font-medium"> -->
                                <!-- {{ act.size | number:'1.0-0' }} shares -->
                                <!-- </span> -->
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center gap-2">
                        <!-- <p class="font-bold text-sm"
                            [ngClass]="act.side?.toLowerCase() === 'buy' || act.side?.toLowerCase() === 'bought' ? 'text-primary-text-green' : 'text-red-600'">
                            ${{ act.amount | number:'1.2-2' }}
                        </p> -->
                        <p class="text-secondary-text-black text-sm">{{ act.time_diff }}
                        </p>

                        <!-- Share Icon -->
                        <a [href]="'https://amoy.polygonscan.com/tx/' + act.txn_hash" target="_blank"
                            class="inline-flex h-5 w-5 items-center justify-center text-secondary-text-black hover:text-black">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <path d="M9.33398 2.6665H13.334V6.6665" stroke="currentColor" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M8.00065 8.00016L13.334 2.66683M6.66732 3.3335H5.60065C4.48055 3.3335 3.92049 3.3335 3.49267 3.55149C3.11635 3.74324 2.81039 4.0492 2.61864 4.42552C2.40065 4.85334 2.40065 5.41339 2.40065 6.5335V10.4002C2.40065 11.5203 2.40065 12.0803 2.61864 12.5081C2.81039 12.8845 3.11635 13.1904 3.49267 13.3822C3.92049 13.6002 4.48055 13.6002 5.60065 13.6002H9.46732C10.5874 13.6002 11.1475 13.6002 11.5753 13.3822C11.9516 13.1904 12.2576 12.8845 12.4493 12.5081C12.6673 12.0803 12.6673 11.5203 12.6673 10.4002V9.3335"
                                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </a>
                    </div>
                </div>
                <div *ngIf="activitiesLoading" class="py-20 text-center">
                    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-black mx-auto"></div>
                </div>
                <div *ngIf="!activitiesLoading && activities.length === 0"
                    class="py-20 text-center text-secondary-text-black font-medium">
                    No activity found.
                </div>
            </div>
        </div>
    </div>
</div>

<app-share-modal *ngIf="isShareModalOpen" (close)="closeShareModal()"></app-share-modal>
<app-reward-modal *ngIf="isRewardModalOpen" (close)="closeRewardModal()"></app-reward-modal>
